import React, { Suspense, lazy } from 'react';
import AppContext from "./Context/AppContext";
import Grid from "@mui/material/Unstable_Grid2";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import KeyboardDoubleArrowLeftSharpIcon from '@mui/icons-material/KeyboardDoubleArrowLeftSharp';
import { useNavigate, useSearchParams } from "react-router-dom";
import PartsAccList from 'shared-components/src/ConfigPage/PartsAccList';
import Datasheet from 'shared-components/src/ConfigPage/Datasheet';
import ZoomImage from 'shared-components/src/ConfigPage/ZoomImage';
import Grid2 from "@mui/material/Grid";
import {
  PublishMessageAddToProject,
  PublishMessageClose,
  PublishMessageSolution,
  PublishMessageSolutionConsoleEvent,
  PublishMessageAddToProjectEZ3
} from "shared-components/src/Infrastructure/PostMessageService";
import ImageModal from 'shared-components/src/ConfigPage/ImageModal';

const QASection = lazy(() => import("shared-components/src/ConfigPage/QASection"));
const NoPageFoundError = lazy(() => import("shared-components/src/views/NoPageFoundError"));
const ProductSubset = lazy(() => import("shared-components/src/views/productSubset"));
const QAInfo = lazy(() => import('shared-components/src/ConfigPage/QAInfo'));
const QueAnsComponent = lazy(() => import('shared-components/src/ConfigPage/QueAnsComponent'));
const OptionsListStack = lazy(() => import('shared-components/src/ConfigPage/OptionsListStack'));
const NoDataFoundPage = lazy(() => import("shared-components/src/views/NoDataFoundPage"));

const dashboardRoutes = [
  {
    path: "/dashboard/product-subset",
    name: "ProductSubset",
    icon: "nc-icon nc-chart-pie-35",
    component: <Suspense fallback={<div className="loader_div">
      <CircularProgress disableShrink />
    </div>}> <ProductSubset PartId={"E2.C044"}
      AppContext={AppContext}
      React={React}
      Grid={Grid}
      Button={Button}
      CircularProgress={CircularProgress}
      axios={axios}
      useNavigate={useNavigate}
      useSearchParams={useSearchParams}
      QAInfo={QAInfo}
      PublishMessageAddToProject={PublishMessageAddToProject}
      PublishMessageClose={PublishMessageClose}
      PublishMessageSolution={PublishMessageSolution}
      PublishMessageSolutionConsoleEvent={PublishMessageSolutionConsoleEvent}
      PublishMessageAddToProjectEZ3={PublishMessageAddToProjectEZ3}
      /></Suspense>,
    layout: "/"
  },
  {
    path: "/dashboard/product-subset/QAsection",
    name: "QASection",
    icon: "nc-icon nc-chart-pie-35",
    component: <Suspense fallback={<div className="loader_div">
      <CircularProgress disableShrink />
    </div>}> <QASection
        React={React}
        CircularProgress={CircularProgress}
        useSearchParams={useSearchParams}
        useNavigate={useNavigate}
        Grid2={Grid2}
        AppContext={AppContext}
        QueAnsComponent={QueAnsComponent}
        PartsAccList={PartsAccList}
        QAInfo={QAInfo}
        OptionsListStack={OptionsListStack}
        ImageModal={ImageModal}
        Datasheet={Datasheet}
        ZoomImage={ZoomImage}
        PublishMessageAddToProject={PublishMessageAddToProject}
        PublishMessageClose={PublishMessageClose}
        PublishMessageSolution={PublishMessageSolution}
        PublishMessageSolutionConsoleEvent={PublishMessageSolutionConsoleEvent}
        PublishMessageAddToProjectEZ3={PublishMessageAddToProjectEZ3}
      /></Suspense>,
    layout: "/"
  },
  {
    path: "/error",
    name: "404Error",
    icon: "nc-icon nc-chart-pie-35",
    component: <Suspense fallback={<div className="loader_div">
      <CircularProgress disableShrink />
    </div>}><NoPageFoundError
        React={React}
        useNavigate={useNavigate}
        KeyboardDoubleArrowLeftSharpIcon={KeyboardDoubleArrowLeftSharpIcon} /> </Suspense>,
    layout: "/"
  },
  {
    path: "/NoDataFoundPage",
    name: "404Error",
    icon: "nc-icon nc-chart-pie-35",
    component: <Suspense fallback={<div className="loader_div">
      <CircularProgress disableShrink />
    </div>}> <NoDataFoundPage
        React={React}
        useNavigate={useNavigate}
        useSearchParams={useSearchParams}
        KeyboardDoubleArrowLeftSharpIcon={KeyboardDoubleArrowLeftSharpIcon}
      /></Suspense>,
    layout: "/"
  },
  {
    path: "/",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: <Suspense fallback={<div className="loader_div">
      <CircularProgress disableShrink />
    </div>}><ProductSubset PartId={"E2.C044"}
      AppContext={AppContext}
      React={React}
      Grid={Grid}
      Button={Button}
      CircularProgress={CircularProgress}
      axios={axios}
      useNavigate={useNavigate}
      useSearchParams={useSearchParams}
      QAInfo={QAInfo}
      PublishMessageAddToProject={PublishMessageAddToProject}
      PublishMessageClose={PublishMessageClose}
      PublishMessageSolution={PublishMessageSolution}
      PublishMessageSolutionConsoleEvent={PublishMessageSolutionConsoleEvent}
      PublishMessageAddToProjectEZ3={PublishMessageAddToProjectEZ3}
      /></Suspense>,
    layout: "/"
  },
]

export default dashboardRoutes;